import replaceWithEmbed from '../utils/replaceWithEmbed';
export default function onSubmit(node, text, editor) {
  var extractorsSelectorFilter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };

  if (!text || !text.length) {
    return;
  }

  return replaceWithEmbed({
    text: text,
    node: node,
    editor: editor,
    bypassSuggestion: true,
    extractorsSelectorFilter: extractorsSelectorFilter
  });
}